import { render, staticRenderFns } from "./ShouninPage.vue?vue&type=template&id=c3afb0d0&scoped=true&"
import script from "./ShouninPage.vue?vue&type=script&lang=ts&"
export * from "./ShouninPage.vue?vue&type=script&lang=ts&"
import style0 from "./ShouninPage.vue?vue&type=style&index=0&id=c3afb0d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3afb0d0",
  null
  
)

export default component.exports